module.exports = __webpack_public_path__ + "img/odoo-for-finance-min.266e14c7.png";